/* Dawn rerenders progress/recommendations with its existing cart sections.
   Custom-element lifecycle expires both initial and AJAX-inserted campaign copy. */
if (!customElements.get('sf-cart-promo')) {
  customElements.define('sf-cart-promo', class extends HTMLElement {
    connectedCallback() {
      this.checkExpiry();
    }
    checkExpiry() {
      clearTimeout(this.expiryTimer);
      const remaining = Date.parse(this.dataset.expires) - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.remove();
        return;
      }
      this.expiryTimer = setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
    }
    disconnectedCallback() {
      clearTimeout(this.expiryTimer);
    }
  });
}
